module.exports = __webpack_public_path__ + "media/images/front/pc/dummy/doctor04-26c3c49ce8ac119898ab6aa7591a20c7.png";